const errorMap = {
	DEAL_NAME_REQUIRED: 'El nombre del chollo es obligatorio',
	AUTH_REQUIRED: 'Debes estar logueado para poder hacer eso',
	SERVER_UNREACHABLE: 'Nuestros servidores echan humo. Intenta en un rato.',
	SERVER_ERROR: 'Ocurrió un error interno. Inténtalo en unos instantes.',
	USERNAME_IN_USE: 'El nombre de usuario ya esta en uso',
	MAIL_IN_USE: 'El email ya esta en uso',
	SALE_PRICE_GREATER_THAN_OLD: 'El precio de ahora no puede ser superior al anterior',
	PASSWORD_MISMATCH: 'La contraseña no es correcta',
	USER_NOT_FOUND: 'El usuario no existe',
	VERIFIED_ACCOUNT_NEEDED: 'Para poder hacer eso antes debes verificar tu cuenta',
	USERNAME_NEEDED: null,
	TEXT_REQUIRED: 'El campo de texto es obligatorio',
	CURRENT_PASSWORD_MISSING: 'Debes introducir tu contraseña actual',
	CURRENT_AND_NEW_PASSWORDS_ARE_EQUAL: 'La nueva contraseña y la anterior son iguales',
	ONLY_IMAGES_ALLOWED: 'Solo se permite adjuntar imágenes',
	VALIDATION_ERROR: null,
	DEAL_NOT_FOUND: 'Post no encontrado',
	DESCRIPTION_VERY_SHORT: 'El Post ha de tener 50 palabras como mínimo. Sigue escribiendo. Ánimo!!!',
	CHOLLOMETRO: 'ALERTA POR SUBNORMAL!! ALERTA POR SUBNORMAL!! VETE PARA CHOLLOMETRO TOPO!',
	OFFER_URL_REPEAT: 'Fíjate, ibas a repetir un post que ha salido hace menos de 5 minutos!!!',
};

export default function translateError(err) {
	const text = errorMap[err] !== undefined ? errorMap[err] : 'Ocurrió un error descatalogado';
	return { text, notify: text !== null };
}
